import React from 'react'
import RNQrCode from 'react-native-qrcode-svg'

export const QRCode = (props: any) => {
  return <RNQrCode {...props} />
}
